/* tslint:disable */
/* eslint-disable */
export enum WorkVoucherAutoFillIssueSeverityEnum {
  Error = 'error',
  Warning = 'warning'
}
